import { HomePageContainer, WelcomeText } from "./style";
import { useEffect, useState } from "react";

const HomePage = () => {
	const [welcomeText, setWelcomeText] = useState<string>("");
	
	useEffect(() => {
		setWelcomeText("İçinde Koç Var Admin Paneline Hoşgeldiniz");
	}, []);

	return (
		<HomePageContainer>
			<WelcomeText dangerouslySetInnerHTML={{ __html: welcomeText }} />
		</HomePageContainer>
	);
};

export default HomePage;

